var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 1.375,
    width: 18.25,
    height: 18.25,
    rx: 9.125,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1769 5.5C13.1725 5.5 15.6647 7.65542 16.1872 10.5C15.6647 13.3446 13.1725 15.5 10.1769 15.5C7.18122 15.5 4.68901 13.3446 4.1665 10.5C4.68901 7.65542 7.18122 5.5 10.1769 5.5ZM10.1769 14.3889C12.53 14.3889 14.5435 12.7511 15.0532 10.5C14.5435 8.24891 12.53 6.61111 10.1769 6.61111C7.8237 6.61111 5.81016 8.24891 5.30047 10.5C5.81016 12.7511 7.8237 14.3889 10.1769 14.3889ZM10.1769 13C8.79614 13 7.67685 11.8807 7.67685 10.5C7.67685 9.11929 8.79614 8 10.1769 8C11.5575 8 12.6769 9.11929 12.6769 10.5C12.6769 11.8807 11.5575 13 10.1769 13ZM10.1769 11.8889C10.9439 11.8889 11.5658 11.2671 11.5658 10.5C11.5658 9.73294 10.9439 9.11111 10.1769 9.11111C9.40982 9.11111 8.78796 9.73294 8.78796 10.5C8.78796 11.2671 9.40982 11.8889 10.1769 11.8889Z",
    fill: "#656565"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 1.375,
    width: 18.25,
    height: 18.25,
    rx: 9.125,
    stroke: "#656565",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.3abfdb116b8830c09f54ee5a7fa2c36e.svg";
export { ForwardRef as ReactComponent };